<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/groupScoreTotalDataDetail')">业绩积分明细查询表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理商'>
            <el-input
              v-model="filters.keyword"
              placeholder="代理商手机号或者姓名"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

            <el-button
              style="margin-left:10px"
              @click="goDown"
              type="danger"
              size="small"
            >到底部</el-button>

            <el-button
              style="margin-left:10px"
              @click="goTop"
              type="warn"
              size="small"
            >到顶部</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
          请选择好条件后，点击统计
        </div>
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          :span-method="objectSpanMethod"
          style="width: 100%"
        >
          <el-table-column
            prop="beginMoney"
            label="期初积分"
          >
          </el-table-column>

          <el-table-column
            prop="totalM"
            label="本期业绩"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="beginMoney"
            label="本期计提比例"
          >
          </el-table-column> -->

          <el-table-column
            prop="totalScore"
            label="本期增加积分"
          >
          </el-table-column>

          <el-table-column label="本期分配及结算">

            <el-table-column
              prop="username"
              label="成员名称"
            >
            </el-table-column>
            <el-table-column
              prop="outM"
              label="分配转出积分"
            >
            </el-table-column>
            <el-table-column
              prop="inM"
              label="接受兑付转入积分"
            >
            </el-table-column>

          </el-table-column>

          <el-table-column
            prop="totalOut"
            label="本期申请兑换积分"
          >
          </el-table-column>

          <el-table-column
            prop="endMoney"
            label="期末积分"
          >
          </el-table-column>

        </el-table>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "groupScoreTotalDataDetail",
  created() {},

  data() {
    return {
      listLoading: false,
      filters: {
        keyword: null,
        startTime: null,
        endTime: null,
      },
      page_num: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight: null,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        } else
        {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }

      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        } else
        {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }

      if (columnIndex === 2) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        } else
        {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }



      if (columnIndex === 6) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        } else
        {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }

      if (columnIndex === 7) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1,
          };
        } else
        {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    goDown() {
      this.$refs.dataTable.bodyWrapper.scrollTop = this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop() {
      this.$refs.dataTable.bodyWrapper.scrollTop = 0;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/group_score_month_data_detail_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.keyword) {
        url = url + "&keyword=" + that.filters.keyword;
      } else {
        that.$message.error({
          showClose: true,
          message: "请填写需要查询的代理的手机号",
          duration: 2000,
        });
        return;
      }
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择结束时间",
          duration: 2000,
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择结束时间",
          duration: 2000,
        });
        return;
      }
      top.location.href = url;
    },
    handleSearch() {
      this.search();
    },

    search() {
      let that = this;
      let params = {
        keyword: that.filters.keyword,
        token: localStorage.getItem("api_token"),
      };
      if (that.filters.keyword) {
        params.keyword = that.filters.keyword;
      } else {
        that.$message.error({
          showClose: true,
          message: "请填写需要查询的代理的手机号",
          duration: 2000,
        });
        return;
      }
      if (that.filters.startTime) {
        params.beginTime = that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择开始时间",
          duration: 2000,
        });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择结束时间",
          duration: 2000,
        });
        return;
      }

      that.listLoading = true;
      API.group_score_month_data_detail(params)
        .then(
          function (result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.tableData = result.result.list;
            } else {
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000,
              });
              return;
            }
          },
          function (err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    // objectSpanMethod({ row, rowIndex }) {
    //   return "table_head";
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
  },
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/groupScoreTotalDataDetail.vue